<!--
 * @Description: 
 * @Date: 2020-07-15 19:04:50
-->
<template>
  <div class="bi-table" v-if="table && table.finalDataCount">
    <div
      class="bi-text-block"
      style="padding: 10px 5px;"
      v-if="normalTable && !longTextTable && table && table.header"
    >
      <el-table :data="table.data" :row-style="rowStyle">
        <template v-for="(item, index) in table.header">
          <el-table-column
            :key="index"
            :prop="item.prop"
            :label="item.label"
            :width="getCellWidth(item)"
            :minWidth="getCellMinWidth()"
            align="center"
          ></el-table-column>
        </template>
      </el-table>
    </div>
    <div
      class="table bi-text-block long-text-block"
      v-if="longTextTable && table && table.header"
    >
      <div
        class="table-column-group"
        v-for="(aItem, aIndex) in dealData.data"
        :key="aIndex"
      >
        <div
          class="table-column-group-item"
          v-for="(item, index) in dealData.header"
          :key="index"
        >
          <div
            class="header"
            :style="{
              width:
                longTextTableHeaderWidth > 0
                  ? `${longTextTableHeaderWidth}px`
                  : ''
            }"
          >
            {{ item.label }}
          </div>
          <div class="content">{{ aItem[item.prop] }}</div>
        </div>
      </div>
    </div>
    <div
      class="table bi-text-block"
      v-if="!normalTable && !longTextTable && table && table.header"
    >
      <div class="table-column-header">
        <div
          class="table-column-title"
          v-for="(item, index) in dealData.header"
          :key="index"
        >
          {{ item.label }}
        </div>
      </div>
      <div class="table-column-group" :style="{ width: groupWidth }">
        <div
          class="table-column"
          v-for="(item, index) in dealData.header"
          :key="index"
        >
          <div
            class="table-column-item"
            v-for="(cItem, cIndex) in dealData.data"
            :key="cIndex"
            v-html="cItem[item.prop]"
          ></div>
        </div>
      </div>
    </div>
    <div
      v-if="table.finalDataCount > 0"
      class="bi-table-footer"
      :class="{ 'map-layout-title': useMapLayout }"
    >
      本次收集数据数：{{ table.finalDataCount }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    table: {
      type: Object,
      default() {
        return {};
      }
    },
    normalTable: {
      type: Boolean,
      default: false
    },
    useMapLayout: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sliceArr: 0,
      canSort: false,
      longTextTableHeaderWidth: 0
    };
  },
  computed: {
    groupWidth() {
      const maxWidth = 750;
      const table = Object.assign({}, this.table);
      const { data } = table;
      const width = data.reduce((pre, cur) => {
        const { b, d } = cur;
        pre += Math.max(`${b}`.length * 20, `${d}`.length * 20) + 20;
        return pre;
      }, 0);
      return `${Math.min(width, maxWidth)}px`;
    },
    longTextTable() {
      try {
        return this.table.data.some(i => `${(i || {}).d}`.length > 40);
      } catch (error) {
        return false;
      }
    },
    dealData() {
      if (this.normalTable) {
        return this.table;
      }
      const table = Object.assign({}, this.table);
      const { header, data } = table;
      table['header'] = header || [];
      table['data'] = data || [];
      // table['data'] = data.concat(data, data, data, data, data, data, data);
      if (this.sliceArr > 0 && table['data'].length > this.sliceArr) {
        if (this.canSort) {
          table['data'].sort((a, b) => {
            return b['v'] - a['v'];
          });
        }
        const otherSum = table['data']
          .slice(this.sliceArr)
          .reduce((pre, cur) => {
            pre += cur['v'] || 0;
            return pre;
          }, 0);
        table['data'] = [
          ...table['data'].slice(0, this.sliceArr),
          {
            d: '其他',
            v: otherSum,
            b: `${Number((otherSum / this.table.finalDataCount) * 100).toFixed(
              2
            )}%`
          }
        ];
      }
      this.resetTable();
      return table;
    }
  },
  methods: {
    rowStyle() {
      if (this.useMapLayout) {
        return { background: 'transparent' };
      } else {
        return {};
      }
    },
    getCellWidth(item) {
      if (this.table['header'].length * 100 > 880) {
        return 860 / this.table['header'].length;
      }
      return item.width || Math.max(100, `${item.label}`.length * 20);
    },
    getCellMinWidth() {
      if (this.table['header'].length * 100 > 880) {
        return 0;
      }
      return 100;
    },
    resetTable() {
      if (!this.normalTable) {
        this.$nextTick(() => {
          try {
            const pDom = this.$el;
            if (pDom.getElementsByClassName) {
              // 判断是否超出长度
              const boxWidth = pDom.offsetWidth;
              const getStyle = (obj, attr) => {
                if (obj.currentStyle) {
                  return obj.currentStyle[attr];
                } else {
                  return document.defaultView.getComputedStyle(obj, null)[attr];
                }
              };
              const maxWidth =
                pDom.parentNode.offsetWidth -
                parseInt(getStyle(pDom.parentNode, 'paddingLeft')) -
                parseInt(getStyle(pDom.parentNode, 'paddingRight'));
              if (boxWidth > maxWidth) {
                this.sliceArr =
                  this.dealData.data.length -
                  parseInt((boxWidth - maxWidth) / 100) -
                  2;
              }
            }
          } catch (error) {
            console.warn(error);
          }
        });
      }
    }
  },
  created() {
    this.canSort = (this.table || {}).sort;
  },
  mounted() {
    this.resetTable();
    if (!this.normalTable && !this.longTextTable) {
      this.$nextTick(() => {
        try {
          const pDom = this.$el;
          if (pDom.getElementsByClassName) {
            // 动态设置单元格高度
            const columnDom = pDom.getElementsByClassName('table-column') || [];
            for (let i = 0; i < columnDom.length; i++) {
              pDom.getElementsByClassName('table-column-title')[
                i
              ].style.height = pDom.getElementsByClassName('table-column')[
                i
              ].style.height = `${columnDom[i].offsetHeight + 2}px`;
            }
          }
        } catch (error) {
          console.warn(error);
        }
      });
    }
    if (this.longTextTable) {
      this.$nextTick(() => {
        try {
          const pDom = this.$el;
          if (pDom.getElementsByClassName) {
            // 动态设置单元格高度
            const columnDom =
              pDom
                .getElementsByClassName('long-text-block')[0]
                .getElementsByClassName('table-column-group')[0]
                .getElementsByClassName('table-column-group-item') || [];
            let max = 0;
            for (let i = 0; i < columnDom.length; i++) {
              max = Math.max(
                columnDom[i].getElementsByClassName('header')[0].offsetWidth,
                max
              );
            }
            this.longTextTableHeaderWidth = max;
          }
        } catch (error) {
          console.warn(error);
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/mixin.scss';
.bi-table {
  margin-top: 30px;
  display: inline-block;
  ::v-deep {
    .el-table {
      background-color: transparent;
    }
    tr {
      background-color: transparent;
    }
    th {
      background-color: transparent;
      & > .cell {
        word-break: keep-all;
        text-align: center;
        font-size: 14px;
        line-height: 1;
        font-weight: bold;
        color: #333333;
      }
    }
    th.is-leaf,
    .el-table td {
      border-bottom: none;
    }
    .el-table::before {
      content: none;
    }
    .el-table .cell {
      font-size: 14px;
    }
    .el-table--scrollable-x .el-table__body-wrapper {
      overflow: hidden;
    }
  }
  &-footer {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
    line-height: 1;
    margin-top: 14px;
    text-align: right;
    letter-spacing: 2px;
    &.map-layout-title {
      position: absolute;
      margin-top: 0;
      top: -20px;
      width: 213px;
      height: 38px;
      background: #ffac28;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      color: #fff;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      @include absolute_mid('x');
    }
  }
  .table {
    padding: 10px 18px;
    display: inline-flex;
    &-column {
      display: inline-flex;
      font-size: 12px;
      line-height: 1;
      &:first-child {
        .table-column-item {
          padding: 5px 5px;
        }
      }
      & + .table-column {
        margin-top: 10px;
      }
      &-header {
        display: inline-flex;
        flex-direction: column;
        flex-shrink: 0;
      }
      &-group {
        display: inline-flex;
        flex-direction: column;
      }
      &-title {
        font-size: 14px;
        line-height: 1.3;
        // flex: 1;
        font-weight: bold;
        color: #333333;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        word-break: keep-all;
        padding: 5px 0;
        & + .table-column-title {
          margin-top: 10px;
        }
      }
      &-item {
        flex: 2;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 400;
        color: #666666;
        padding: 5px 1px;
        line-height: 1.3;
        // word-break: keep-all;
      }
    }
  }
  .long-text-block {
    flex-wrap: wrap;
    .table-column-group {
      width: 100%;
      border-bottom: 1px solid rgba(51, 51, 51, 0.14);
      padding: 8px 0;
      &:last-child {
        border-bottom: none;
      }
      &-item {
        display: flex;
        padding: 18px 0;
        .header {
          font-size: 14px;
          line-height: 1.3;
          font-weight: bold;
          color: #333333;
          flex-shrink: 0;
          margin-right: 15px;
          text-align: left;
        }
        .content {
          font-size: 12px;
          flex: 2;
          text-align: left;
          font-weight: 400;
          color: #666666;
          line-height: 1.3;
          letter-spacing: 1px;
        }
      }
    }
  }
}
</style>
